var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"stores-list",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('StoresListComp',{attrs:{"displayImage":true,"displayGoToDetail":true,"select":false,"referenceLocation":_vm.locationCoords}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }